var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "input-box",
    class: {
      error: !_vm.isValid
    },
    on: {
      "click": function ($event) {
        return _vm.$refs['textInput'].focus();
      }
    }
  }, [_c('input', {
    ref: "textInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput,
      "blur": _vm.blurDelete
    }
  }), _c('span', {
    staticClass: "placeholder",
    class: {
      active: _vm.value
    }
  }, [_vm._v(_vm._s(_vm.tt(_vm.placeholder)))]), !_vm.isValid ? _c('span', {
    staticClass: "noti"
  }, [_vm._v(_vm._s(_vm.validText))]) : _vm._e(), _vm.value.length > 0 ? _c('button', {
    on: {
      "click": _vm.clickDelete
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/delete.svg")
    }
  })]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }